<script>
import Layout from "@/views/layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../../app.config";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Copass/Followup/components/FollowupTable";
import ItemAPI from "@/services/items/itemsAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Listado de Actas de Seguimiento / Copasst Vigía de Salud",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title: "Listado de Actas de Seguimiento / Copasst Vigía de Salud",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.1.6 Acta de conformación Copasst Vigía de salud",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id}/acta-conformacion1.1.6`,
        },
        {
          text: "Listado de seguimiento Copasst",
          active: true,
        },
      ],
      itemData: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      copasstID: Number(this.$route.params.id),
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(6)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    goBack() {
      window.location.href = `/forms/estandares/${this.companyID}/acta-conformacion1.1.6`;
    },
  },
  mounted() {
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">

            <div class="col-12 text-right m-b-0 mb-2">
              <button :disabled="!allowAccess() || !getRole('Crear')"
                @click="goPage(`/forms/estandares/${copasstID}/acta-reunion`)" class="btn btn-primary m-l-5 ml-1">
                Agregar
              </button>
              <button @click="goBack" id="goback" class="btn btn-secondary m-l-5 ml-1">
                <i class="fas fa-arrow-left"></i>
              </button>
              <b-tooltip target="goback" placement="left">Volver</b-tooltip>
            </div>

            <Table />
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
  </Layout>
</template>
